import { Route } from "react-router-dom";

import "modules/Auth/Auth.scss";
import { Login } from "modules/Auth/components";
import { PATHS } from "router/paths";

const Auth = () => {
  return (
    <div className="Auth">
      <div className="auth__overlay">
        <div className="auth_container">
          <div className="auth_rhs">
            <div className="rhs_auth_box">
              <Route exact path={[PATHS.HOME, PATHS.LOGIN]} render={() => <Login />}></Route>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
